import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

type BreadcrumbProps = {
	items: Array<{
		name: string;
		url: string;
	}>;
	className?: string;
};

export const Breadcrumb = ({ items, className = "" }: BreadcrumbProps) => {
	if (!items || items.length === 0) return null;

	return (
		<nav aria-label="Breadcrumb" className={`py-4 flex items-center text-sm text-gray-600 ${className}`}>
			{items.map((item, index) => {
				// If it's the last item, render it as a span (current page)
				const isLastItem = index === items.length - 1;
				
				return (
					<div key={item.url} className="flex items-center">
						{index > 0 && <ChevronRight className="w-4 h-4 mx-2" />}
						
						{isLastItem ? (
							<span className="text-gray-800 font-medium truncate">{item.name}</span>
						) : (
							<Link to={item.url} className="hover:text-[#866BFF]">
								{item.name}
							</Link>
						)}
					</div>
				);
			})}
		</nav>
	);
};

export default Breadcrumb;
